import { Routes, Route, Navigate } from 'react-router-dom'
import { ProductGrid } from "@/components/sections/investment/ProductGrid"
import { AssetManagement } from "@/components/sections/investment/AssetManagement"
// TODO: Add ALL THINGS INVESTMENT RELATED HERE (software, digital funds, ...), THEN IN @INVESTMENTSERVICESPAGE all things specific to investment services
export function InvestmentPage() {
  return (
    <Routes>
      <Route index element={<Navigate to="software" replace />} />
      <Route path="software" element={<ProductGrid />} />
      <Route path="asset-management" element={<AssetManagement />} />
    </Routes>
  )
} 